import { styled as styling } from "@mui/material/styles";

export const SectionFrame = styling("section")(() => ({
    width: "100%",
    maxWidth: "1240px",
    minHeight: "272px",
    margin: "0 auto",
    borderRadius: "16px",
    backgroundColor: "#F0F1FE",
    padding: "40px",
    boxSizing: "border-box",

    "@media (max-width: 767px)": {
        minHeight: "unset",
        padding: "24px 16px",
        borderRadius: "12px",
    },
}));

export const Title = styling("h2")(() => ({
    margin: 0,
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: "Georgia",
    fontSize: "32px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: "32px",

    "@media (max-width: 767px)": {
        fontSize: "24px",
        lineHeight: "28px",
    },
}));

export const LogoRow = styling("div")(() => ({
    marginTop: "56px",
    display: "grid",
    gridTemplateColumns: "repeat(3, 180px)",
    justifyContent: "center",
    alignItems: "center",
    columnGap: "60px",
    rowGap: "24px",

    "@media (max-width: 767px)": {
        marginTop: "24px",
        width: "100%",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        columnGap: "8px",
        rowGap: "12px",
    },
}));

export const LogoLink = styling("a")(() => ({
    position: "relative",
    width: "180px",
    height: "88px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 0.2s ease",

    "&:hover": {
        transform: "scale(1.08)",
    },

    "&:hover .default-logo": {
        opacity: 0,
    },

    "&:hover .hover-logo": {
        opacity: 1,
    },

    "@media (max-width: 767px)": {
        width: "100%",
        height: "48px",
    },
}));

export const DefaultLogo = styling("img")(() => ({
    maxHeight: "88px",
    maxWidth: "240px",
    objectFit: "contain",
    transition: "opacity 0.2s ease",

    "@media (max-width: 767px)": {
        maxHeight: "40px",
        maxWidth: "100%",
        width: "100%",
    },
}));

export const HoverLogo = styling("img")(() => ({
    position: "absolute",
    maxHeight: "88px",
    maxWidth: "240px",
    objectFit: "contain",
    opacity: 0,
    transition: "opacity 0.2s ease",

    "@media (max-width: 767px)": {
        maxHeight: "40px",
        maxWidth: "100%",
        width: "100%",
    },
}));
